import { render, staticRenderFns } from "./AdmissionsYearWeeks.vue?vue&type=template&id=797904dc"
import script from "./AdmissionsYearWeeks.vue?vue&type=script&lang=js"
export * from "./AdmissionsYearWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797904dc')) {
      api.createRecord('797904dc', component.options)
    } else {
      api.reload('797904dc', component.options)
    }
    module.hot.accept("./AdmissionsYearWeeks.vue?vue&type=template&id=797904dc", function () {
      api.rerender('797904dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsYearWeeks.vue"
export default component.exports